import React from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import PropTypes from 'prop-types';

const FooterPaginacionOrdenes = ({
    pageSize,
    totalRecords,
    pageNumber,
    page = [],
    onPageSizeChange,
    onNextPage,
    onPreviousPage
}) => {
    const totalPages = Math.max(1, Math.ceil(totalRecords / pageSize));
    const canPreviousPage = pageNumber > 1;
    const canNextPage = pageNumber < totalPages;
    const fromRecord = totalRecords === 0 ? 0 : pageSize * (pageNumber - 1) + 1;
    const toRecord = totalRecords === 0 ? 0 : Math.min(pageSize * (pageNumber - 1) + page.length, totalRecords);

    return (
        <Col xs={12} className="d-flex flex-column gap-2">
            <div className="d-flex align-items-center">
                <Form.Label className="mb-0 me-2 fs--2 text-600">Mostrar:</Form.Label>
                <Form.Select
                    size="sm"
                    value={pageSize}
                    onChange={onPageSizeChange}
                    style={{ width: 'auto' }}
                >
                    <option value={10}>10 filas</option>
                    <option value={15}>15 filas</option>
                    <option value={30}>30 filas</option>
                    <option value={50}>50 filas</option>
                    <option value={100}>100 filas</option>
                </Form.Select>
            </div>
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                <p className="mb-0 fs--1 text-600">
                    Mostrando: {fromRecord} a {toRecord} de {totalRecords}
                </p>
                <div className="d-flex gap-2">
                    <Button
                        size="sm"
                        variant={canPreviousPage ? 'primary' : 'light'}
                        disabled={!canPreviousPage}
                        onClick={onPreviousPage}
                    >
                        Anterior
                    </Button>
                    <Button
                        size="sm"
                        variant={canNextPage ? 'primary' : 'light'}
                        disabled={!canNextPage}
                        onClick={onNextPage}
                    >
                        Siguiente
                    </Button>
                </div>
            </div>
        </Col>
    );
};

FooterPaginacionOrdenes.propTypes = {
    pageSize: PropTypes.number.isRequired,
    totalRecords: PropTypes.number.isRequired,
    pageNumber: PropTypes.number.isRequired,
    page: PropTypes.array,
    onPageSizeChange: PropTypes.func.isRequired,
    onNextPage: PropTypes.func.isRequired,
    onPreviousPage: PropTypes.func.isRequired
};

export default FooterPaginacionOrdenes;
